import { Divider, Skeleton as SkeletonAntd } from 'antd'
// styles
import styles from '../../../styles.module.scss'

const Skeleton: React.FC<{ active?: boolean }> = ({ active = true }) => {
  return (
    <div className={styles.transactionRecordSkeleton}>
      <div className="skeletonComponent">
        <SkeletonAntd.Input active={active} size={'small'} className="date" />
        <Divider type="vertical" />
        <SkeletonAntd.Input active={active} size={'small'} className="type" />
      </div>
      <SkeletonAntd.Input active={active} size={'small'} className="points" />
    </div>
  )
}

export default Skeleton
